const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    createNew: () =>
        __('Opret ny Jobagent'),
    editJobagent: () =>
        __('Ret Jobagent'),
    active: () =>
        __('Aktive'),
    activeEmpty: () =>
        __('Du har ingen aktive Jobagenter.'),
    inactive: () =>
        __('Inaktive'),
    inactiveEmpty: () =>
        __('Du har ingen inaktive Jobagenter.'),
    all: () =>
        __('Alle'),
    allEmpty: () =>
        __('Du har ingen Jobagenter.'),
    confirmSaveTitle: () =>
        __('Vil du gemme?'),
    confirmSaveMessage: () =>
        __('Du har lavet ændringer i din Jobagent som ikke er blevet gemt. Hvis du fortsætter uden at gemme vil disse ændringer gå tabt.'),
    cancel: () =>
        __('Annuller'),
    continueWithoutSaving: () =>
        __('Fortsæt uden at gemme'),
    saveChanges: () =>
        __('Gem ændringer'),
    confirmDelete: () =>
        __('Vil du slette Jobagenten?'),
    confirmDeleteCurrent: () =>
        __('Du er i gang med at redigere Jobagenten. Ønsker du at slette den?'),
    duplicateWarning: () =>
        __('Du har allerede en Jobagent med de samme søgeparametre:'),
    oldCategoriesWarning: () =>
        __('Vi har opdateret vores kategorier for at give dig det bedste overblik over det danske it-jobmarked. Anvendelse af gamle kategorier er highlightet med orange.'),
};
